import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, of } from 'rxjs';
import { CookieService } from './cookie.service';
import { KeycloakAuthService } from './keycloak-auth.service';
import { environment } from '../../../environments/environment';

@Injectable({
	providedIn: 'root',
})
export class AuthService {
	private dialogTokenHasExpired: any = null;

	constructor(
		private router: Router,
		private cookieService: CookieService,
		private keycloakAuthService: KeycloakAuthService,
		private http: HttpClient,
	) {}

	private parseJwt(token: any): any {
		try {
			const base64Url = token.split('.')[1];
			const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
			const jsonPayload = decodeURIComponent(
				atob(base64)
					.split('')
					.map((c) => {
						return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
					})
					.join(''),
			);

			return JSON.parse(jsonPayload);
		} catch (error) {
			return false;
		}
	}

	private checkIfTokenHasExpired(): boolean {
		const access_token: string | null = localStorage.getItem('access_token');

		if (access_token && access_token !== '') {
			const jwt = this.parseJwt(access_token);
			if (!jwt) {
				return true;
			}
			const exp = jwt.exp * 1000;

			return new Date().getTime() >= exp;
		}

		return true;
	}

	getToken(): any {
		if (this.checkIfTokenHasExpired()) {
			console.warn('JWT expired');
			if (this.dialogTokenHasExpired == null) {
				this.dialogTokenHasExpired = true;
				// this.logout();

				localStorage.removeItem('role');
				localStorage.removeItem('access_token');
				this.router.navigate(['login']);
			}
			return;
		}
		return localStorage.getItem('access_token');
	}

	public logout(): void {
		// Revocar la sesión en el servidor antes de limpiar el storage local.
		// La llamada es best-effort: si falla (token ya expirado, red caída, etc.)
		// el usuario se desloguea igual en el cliente.
		const token =
			localStorage.getItem('access_token') || sessionStorage.getItem('restricted_token');

		if (token) {
			this.http
				.post(
					environment.apiUrl + '/logout',
					{},
					{ headers: new HttpHeaders({ Authorization: 'Bearer ' + token }) },
				)
				.pipe(catchError(() => of(null)))
				.subscribe();
		}

		localStorage.removeItem('role');
		localStorage.removeItem('access_token');
		sessionStorage.removeItem('restricted_token');
		this.router.navigate(['login']);
		this.keycloakAuthService.logout();
	}
}